<template>
  <div
    :class="[
      'max-w-212.5 mx-auto',
      {
        'text-center flex flex-col items-center': center,
        'max-w-300': wide,
        'grid gap-8 md:grid-cols-2 lg:gap-15 transition-[gap]': !center && wide,
      },
    ]"
  >
    <p v-if="subtitle" class="flex items-center gap-2.5 mb-4 font-semibold w-max max-w-full">
      <span class="w-2.5 h-2.5 bg-(--accent-color) rounded-full" />
      <span class="font-semibold">{{ subtitle }}</span>
    </p>
    <h2 v-if="title" class="text-2xl md:text-5xl font-semibold w-full">{{ title }}</h2>
    <RawHtml
      v-if="description"
      :html="description"
      class="mt-5 text-(--title-block-grey-dark) max-w-250"
      :section_bg="section_bg"
    />
    <OptionalButtons :buttons="buttons" class="mt-6 md:mt-8" />
  </div>
</template>

<script lang="ts">
import { RawHtml } from "@/components/helpers";
import OptionalButtons from "@/components/blocks/OptionalButtons.vue";
import type { PropType } from "vue";

export default {
  name: "TitleBlock",
  components: { OptionalButtons, RawHtml },
  props: {
    buttons: {
      type: Array as PropType<Link[]>,
      default: [],
    },
    center: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    section_bg: {
      type: String,
      default: "",
    },
  },
};
</script>
